import { useQuery } from "@tanstack/react-query";

import { defaultEntityLinkRouterHandler } from "helpers/routing/EntityLinkRouter/EntityLinkRouter.api.handler";
import { type IEntityRecord } from "helpers/routing/EntityLinkRouter/EntityLinkRouter.api.types";

import { routes } from "utilities/routes";

import { type ISharingConfig } from "commonComponents/entity/sharing/EntityShareButton/EntityShareButton";

export function getShareUrl(record: IEntityRecord) {
    const shareUrl = location.href
        // clear out any query params
        .replace(location.search, "")
        // clear out any hash
        .replace(location.hash, "")
        // and generate the new link url
        .replace(
            location.pathname,
            `${routes.appBase}${routes.entityLink.getLink(record.externalId)}`,
        );

    return shareUrl;
}

export const getShareLink = async (config: ISharingConfig) => {
    const { overrideGetEntityRecord, entity } = config;
    let entityRecord: IEntityRecord;
    if (overrideGetEntityRecord) {
        entityRecord = await overrideGetEntityRecord(entity);
    } else {
        entityRecord = await defaultEntityLinkRouterHandler.insert(entity);
    }

    return getShareUrl(entityRecord);
};

// Wrap getShareLink around tanstack useQuery
export const useGetShareLink = (shareConfig: ISharingConfig | undefined) => {
    return useQuery({
        queryKey: ["getShareLink", shareConfig],
        queryFn: async () => {
            if (!shareConfig) {
                throw new Error("Share config was not defined");
            }
            return await getShareLink(shareConfig);
        },
        retry: 2,
        enabled: false,
    });
};
